import { Preferences } from '@capacitor/preferences'
import User from '@/assets/ts/interfaces/User'

const TOKEN_KEY = 'auth-token'
const USER_KEY = 'auth-user'

export class AuthService {
  async setToken( token: string ): Promise<void> {
    await Preferences.set( {
      key: TOKEN_KEY,
      value: token
    } )
  }

  async getToken(): Promise<string | null> {
    const { value } = await Preferences.get( { key: TOKEN_KEY } )
    console.log( 'token', value )
    return value
  }

  async setAbilibeeToken( token: string ): Promise<void> {
    await Preferences.set( {
      key: 'abilibee-token',
      value: token
    } )
  }
  async setFirebaseToken( token: string ): Promise<void> {
    await Preferences.set( {
      key: 'firebase-token',
      value: token
    } )
  }

  async getFirebaseToken(): Promise<string | null> {
    const { value } = await Preferences.get( { key: 'firebase-token' } )
    console.log( 'firebase-token', value )
    return value
  }

  async getAbilibeeToken(): Promise<string | null> {
    const { value } = await Preferences.get( { key: 'abilibee-token' } )
    return value
  }

  async setRefreshToken( token: string ): Promise<void> {
    await Preferences.set( {
      key: 'refresh-token',
      value: token
    } )
  }

  async getRefreshToken(): Promise<string | null> {
    const { value } = await Preferences.get( { key: 'refresh-token' } )
    return value
  }

  async setTokenExpiry( expiry: string ): Promise<void> {
    await Preferences.set( {
      key: 'token-expiry',
      value: expiry
    } )
  }

  async getTokenExpiry(): Promise<string | null> {
    const { value } = await Preferences.get( { key: 'token-expiry' } )
    return value
  }

  async removeToken(): Promise<void> {
    await Preferences.remove( { key: TOKEN_KEY } )
  }

  async removeAbilibeeToken(): Promise<void> {
    await Preferences.remove( { key: 'abilibee-token' } )
  }

  async removeRefreshToken(): Promise<void> {
    await Preferences.remove( { key: 'refresh-token' } )
  }

  async setUser( user: User ): Promise<void> {
    await Preferences.set( {
      key: USER_KEY,
      value: JSON.stringify( user )
    } )
  }

  async getUser(): Promise<User | null> {
    const { value } = await Preferences.get( { key: USER_KEY } )
    return value ? JSON.parse( value ) : null
  }

  async removeUser(): Promise<void> {
    await Preferences.remove( { key: USER_KEY } )
  }

  async logout(): Promise<void> {
    await Preferences.clear()
  }

  async isAuthenticated(): Promise<boolean> {
    const token = await this.getToken()
    return !! token
  }

  async rememberMe( email: string, password: string ): Promise<void> {
    await Preferences.set( {
      key: 'remember-me',
      value: JSON.stringify( { email, password } )
    } )
  }

  async getRememberMe(): Promise<{ email: string, password: string } | null> {
    const { value } = await Preferences.get( { key: 'remember-me' } )
    return value ? JSON.parse( value ) : null
  }

  async removeRememberMe(): Promise<void> {
    await Preferences.remove( { key: 'remember-me' } )
  }
}

export const authService = new AuthService()